export const ELLIPSE_TOOL_ID = "ellipse";

const drawEllipse = ({ ctx, from, to }) => {
  const cx = (from.x + to.x) / 2;
  const cy = (from.y + to.y) / 2;
  const rx = Math.abs(to.x - from.x) / 2;
  const ry = Math.abs(to.y - from.y) / 2;

  ctx.beginPath();
  ctx.ellipse(cx, cy, rx, ry, 0, 0, Math.PI * 2);
  ctx.stroke();
};

export const ellipseToolConfig = {
  id: ELLIPSE_TOOL_ID,
  usesPreview: true,
  cursor: "crosshair",
  onStart: () => true,
  onMove: ({ ctx, lastPointRef, nextPoint }) => {
    drawEllipse({ ctx, from: lastPointRef.current, to: nextPoint });
  },
  onEnd: ({ ctx, lastPointRef, endPoint }) => {
    drawEllipse({ ctx, from: lastPointRef.current, to: endPoint });
  },
};

const EllipseToolButton = ({ activeTool, onSelectTool }) => {
  return (
    <button
      type="button"
      className={`btn ${
        activeTool === ELLIPSE_TOOL_ID ? "btn-dark" : "btn-outline-dark"
      }`}
      onClick={() => onSelectTool(ELLIPSE_TOOL_ID)}
      title="Ellipse"
      aria-label="Ellipse"
    >
      ◯
    </button>
  );
};

export default EllipseToolButton;
